<template>
  <v-container fluid>
    <!-- Header Section -->
    <div class="staking-header">
      <h3 class="staking-title">
        {{ $t("staking.header.title") }}
      </h3>
      <p class="staking-description">
        {{ $t("staking.header.description") }}
      </p>
    </div>

    <!-- Main Content Section -->
    <v-row align="center" justify="center" justify-md="space-between">
      <!-- Left Side - Links -->
      <v-col
        cols="12"
        md="6"
        class="d-flex flex-column align-center justify-center justify-md-start flex-sm-row"
        style="gap: 32px;cursor: pointer;"
      >
        <div
          v-for="(item, index) in content"
          :key="index"
          :class="{ active: item.active }"
          class="d-flex align-center"
          @click="linkAction(item.link)"
        >
          <span>{{ item.text }}</span>
          <LocalizedImage
            :src="require('@/assets/image/staking/arrow.svg')"
            alt="arrow"
            width="12"
            height="12"
            :rotate-in-english="true"
            class="ms-2"
          />
        </div>
      </v-col>
      <!-- Right Side - Quick Access -->
      <v-col cols="12" md="6" class="quick-access-main">
        <p class="gray3--text md-font500-16">
          {{ $t("staking.header.quick_access") }}
        </p>
        <v-divider class="staking-divider"></v-divider>
        <a
          class="d-flex align-center justify-space-between quick-item"
          style="cursor: pointer;color: inherit"
          href="https://www.excoino.com/campaign/investment/"
        >
          <span>
            {{ $t("staking.header.crypto_pool_investment_fund") }}
          </span>
          <LocalizedImage
            :src="require('@/assets/image/staking/arrow.svg')"
            alt="arrow"
            width="12"
            height="12"
            :rotate-in-english="true"
            style="max-width: 12px"
          />
        </a>

        <a
          href="https://www.excoino.com/campaign/uranus"
          class="d-flex align-center justify-space-between quick-item"
          style="cursor: pointer;color: inherit"
        >
          <span>
            {{ $t("staking.header.uranus") }}
          </span>
          <LocalizedImage
            :src="require('@/assets/image/staking/arrow.svg')"
            alt="arrow"
            width="12"
            height="12"
            :rotate-in-english="true"
            style="max-width: 12px"
          />
        </a>
      </v-col>
    </v-row>

    <!--    Modal-->
    <v-dialog v-model="isOpenDialog" width="500">
      <v-card color="gray9" class="pa-4">
        <div class="d-flex align-center justify-space-between mb-6">
          <span>{{ $t("staking.header.link_3") }}</span>
          <v-icon
            clr="var(--v-gray1-base)"
            style="cursor:pointer;"
            @click="isOpenDialog = false"
            >$modalClose</v-icon
          >
        </div>
        <div>
          <p style="line-height: 2">
            {{ $t("staking.header.dialog_des") }}
          </p>
        </div>
        <v-btn
          color="primary"
          class="py-4"
          block
          @click="isOpenDialog = false"
          >{{ $t("staking.header.dialog_action") }}</v-btn
        >
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import LocalizedImage from "@/components/Shared/LocalizedImage/index.vue";

export default {
  components: {
    LocalizedImage
  },
  data() {
    return {
      content: [
        {
          text: this.$t("staking.header.link_1"),
          link: "",
          active: true
        },
        {
          text: this.$t("staking.header.link_2"),
          link: "scroll",
          active: false
        },
        {
          text: this.$t("staking.header.link_3"),
          link: "dialog",
          active: false
        }
      ],
      isOpenDialog: false
    };
  },
  methods: {
    linkAction(link) {
      if (link === "scroll") {
        const el = document.getElementById("faqSection");
        el?.scrollIntoView({ behavior: "smooth" });
      }
      if (link === "dialog") {
        this.isOpenDialog = true;
      }
    }
  }
};
</script>

<style scoped>
/* ===== Staking Header ===== */
.staking-header {
  margin-bottom: 24px;
}

.staking-title {
  font-weight: 400;
  font-size: 32px;
  margin-top: 40px;
  margin-bottom: 8px;
}

.staking-description {
  color: var(--v-gray3-base);
  font-weight: 300;
  font-size: 16px;
  text-align: justify;
  line-height: 1.6;
  max-width: 50%;
}

@media screen and (max-width: 928px) {
  .staking-header {
    text-align: center;
  }
  .staking-description {
    max-width: 100%;
  }
}

.active {
  background-color: var(--v-primary4-base);
  padding: 10px;
  border-radius: 8px;
}

/* ===== Quick Access Right Side ===== */
.quick-access-main {
  max-width: 300px;
  //margin-inline: auto;
}

.quick-item {
  font-weight: 400;
  font-size: 14px;
  border-bottom: 1px solid var(--v-primary6-base);
  padding-bottom: 8px;
  margin-top: 20px;
}
</style>
